module.exports = __webpack_public_path__ + "img/bg-login-page.25450c39.svg";